export default __webpack_public_path__ + "static/media/risk-icon.63ca8efa.svg";